import {API_URL} from '../../../tenant/apiBase'
import {tenantTaxEnabled} from '../../../tenant/tenantState'
import {
  DAILY_DEAL_ACTIONS, IProductDraftModel,
  IProductModel,
  PRODUCT_ACTIONS,
  PRODUCT_REQUEST_TYPE,
} from './_models'
import axios from 'axios'
import {productState} from './reducers'
import {prepareFilterParams} from '../../orders/core/_requests'
import {appendOrderedImages, appendVariationImages} from '../utils/productImages'

export const ADD_PRODUCT = `${API_URL}/api/partner-portal/product`
export const VALIDATE_ADD_PRODUCT = `${API_URL}/api/partner-portal/product/validate-duplicate-barcode`
export const VALIDATE_PRODUCT_IMAGES = `${API_URL}/api/partner-portal/product/validate-more-images`
export const EDIT_PRODUCT = `${API_URL}/api/partner-portal/product/edit-product`
export const GET_PRODUCT_INFO = `${API_URL}/api/partner-portal/product/product`
export const GET_REQUEST_INFO = `${API_URL}/api/partner-portal/product/request-data`
export const PRODUCT_ACTION = `${API_URL}/api/partner-portal/product/` // ex: out-of-stock?product_id=47979
export const GET_LENGTH_CLASSES = `${API_URL}/api/partner-portal/common/length-classes`
export const GET_WEIGHT_CLASSES = `${API_URL}/api/partner-portal/common/weight-classes`
export const GET_BRANDS = `${API_URL}/api/partner-portal/common/brands`
export const GET_COLORS = `${API_URL}/api/partner-portal/common/colors`
export const GET_SIZES = `${API_URL}/api/partner-portal/common/sizes`
export const GET_RECOMMENDED_AGES = `${API_URL}/api/partner-portal/common/recommended-ages`
export const GET_TAX = `${API_URL}/api/partner-portal/common/tax-types`
export const GET_GENDERS = `${API_URL}/api/partner-portal/common/genders`
export const GET_PRODUCTS_LIST = `${API_URL}/api/partner-portal/product/products`
export const GET_DRAFT_PRODUCTS_LIST = `${API_URL}/api/partner-portal/product/draft-products`
export const DELETE_DRAFT_PRODUCT = `${API_URL}/api/partner-portal/product/delete-draft`
export const GET_PRODUCTS_REQ_LIST = `${API_URL}/api/partner-portal/product/product-request`
export const GET_ADD_DISCOUNT_REQ_LIST = `${API_URL}/api/partner-portal/special/request`
export const GET_DAILY_DEAL_LIST = `${API_URL}/api/partner-portal/special/get-daily-deals`
export const DELETE_DAILY_DEAL_PRODUCT = `${API_URL}/api/partner-portal/special/daily-deals`
export const ADD_ADD_DAILY_DEAL_PRODUCT = `${API_URL}/api/partner-portal/special/daily-deals`
export const APPLY_DAILY_DEAL_PRODUCT = `${API_URL}/api/partner-portal/special/apply-daily-deals`
export const APPLIED_DAILY_DEAL_LIST = `${API_URL}/api/partner-portal/special/applied-daily-deal`
export const SET_PRODUCT_TO_INACTIVE = `${API_URL}/api/partner-portal/special/deactivate-discount`
export const GET_LOSS_PRODUCTS_LIST = `${API_URL}/api/partner-portal/po/loss-products-list`
export const AUTO_COMPLETE_CATEGORIES = `${API_URL}/api/partner-portal/product/category-complete`
export const CATEGORIES_LAYERS = `${API_URL}/api/partner-portal/product/get-categories`
export const SAVE_DRAFT = `${API_URL}/api/partner-portal/product/save-draft`
export const ADD_BRAND = `${API_URL}/api/partner-portal/brand`

export function addBrand(
  language: string,
  token: string | undefined,
  data: {
    name: {
      en: string;
      ar: string;
    };
    image?: File | null;
  }
) {
  const formData = new FormData()
  formData.append('name[en]', data.name.en)
  formData.append('name[ar]', data.name.ar)
  if (data.image) {
    formData.append('image', data.image)
  }

  return axios.post<any>(ADD_BRAND, formData, {
    headers: {
      token: token || '',
      language,
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function addProduct(
  language: string,
  token: string | undefined,
  data: productState,
  productID: string | undefined | null,
  specialPriceAction?: 'deactivate' | 'keep_active',
  shopUser: boolean = false
) {
  const formData = new FormData()
  let url = ADD_PRODUCT
  if (productID) {
    // productID can arrive as a number (the numeric product_id, e.g. 156) even though the type says
    // string — calling .includes()/.match() on a number throws "includes is not a function" and blanks
    // the page. Normalise to a string first.
    const pid = String(productID)
    if (pid.includes('&')) {
      const regex = /&(.+)/;
      const matchType = pid.match(regex);
        // Submit/edit a product request via product/edit-request: it's in the
        // token-authed product/* group (like save-draft) and returns JSON. The
        // requests/edit route sits behind web/session auth and 302-redirects to
        // '/', which the SPA can't follow (CORS), so it can't be used here.
        url = ADD_PRODUCT;
        const regex2 = /(\d+)(?=&|$)/;
        let match =  pid.match(regex2)
        formData.append('request_id', match ? match[1] : '')

    } else {
      url = EDIT_PRODUCT
     formData.append('product_id', pid)
    }
  }

  // Only send the default image when the user uploaded a new file; otherwise
  // omit it so the backend keeps the existing image (and a non-file value can't
  // fail image validation). Same guard as the product_image[] gallery below.
  if (data.image.value instanceof File) {
    formData.append('image', data.image.value)
  }

  formData.append('barcode', data.barcode.value)
  if(!productID){
    formData.append('category', data.categoryName.value)
  }
  formData.append('categoryID', data.categoryID.value)
  formData.append('generate_flag', String(data.generate_flag))
  // formData.append('quantity_per_box', data.quantityPerBox || '0')
  // formData.append('cost_price', data.costPrice.value)
  formData.append('price', data.salePrice.value)
  formData.append('supplier_quantity', data.quantity.value)

  // "Create package": send the flag + composition. The backend validates the
  // children are the supplier's own products and computes the derived price.
  if (data.createPackage && Array.isArray(data.packageChildren) && data.packageChildren.length > 0) {
    formData.append('create_package', '1')
    formData.append(
      'package_children',
      JSON.stringify(
        data.packageChildren.map((c) => ({
          barcode: c.barcode,
          quantity: c.quantity,
          product_id: c.product_id,
        }))
      )
    )
    // No supplier discount on packages — the price is the components' sum.
    formData.append('package_discount_type', 'none')
    formData.append('package_discount_value', '0')
  }
  //formData.append('tax_class_id', data.tax_class_id.value)
  if (tenantTaxEnabled()) {
    formData.append('tax_type', data.tax_class_id.value)
  }

  // Add special price action if provided
  if (specialPriceAction) {
    formData.append('special_price_action', specialPriceAction)
  }
  formData.append('manufacturer_id', data.manufacturer_id.value)
  formData.append('model', data.model.value)
  formData.append('company_code', data.companyCode ?? '')
  formData.append('product_description[1][name]', data.productNameEn.value)
  formData.append('product_description[1][description]', data.productDescriptionEn.value)
  formData.append('product_description[6][name]', data.productNameAr.value)
  formData.append('product_description[6][description]', data.productDescriptionAr.value)

  if (data.aboutEn.value) {
    formData.append('product_description[1][about_product]', data.aboutEn.value)
  }

  if (data.aboutAr.value) {
    formData.append('product_description[6][about_product]', data.aboutAr.value)
  }

  formData.append('color_id', data.color)
  // A rejected variant sibling comes back through this simple-product path
  // with its size flattened into state — resend it or it's lost on resubmit.
  // Absent (not empty) when unset is fine: the simple form has no size input,
  // so the value can only round-trip unchanged, never be cleared.
  if (data.size) {
    formData.append('size_id', data.size)
  }
  formData.append('gender_id', data.gender)

  formData.append('length', data.dimensionL)
  formData.append('length_class_id', data.lengthClass)
  formData.append('width', data.dimensionW)
  formData.append('height', data.dimensionH)
  formData.append('recommended_age_id', data.recommendedAge.value)

  formData.append('weight', data.weight)
  formData.append('weight_class_id', data.weightClass)
  formData.append('youtube_video_url', data.youtubeUrl)
  // A shop never sees the Expiry date field (the server ignores it for a shop), so it is not sent:
  // a stored past date would otherwise refuse the edit on a field the shop cannot fix.
  if (!shopUser) {
    formData.append('expiry_date', data.expiryDate.value || '0000-00-00')
  }

  appendOrderedImages(formData, data.product_image)

  data.deleted_images.forEach((product_image_id) => {
    formData.append('deleted_images[]', product_image_id)
  })

  if (data.variations && data.variations.length > 0) {
    data.variations.forEach((variation, index) => {
      formData.append(`variations[${index}][barcode]`, variation.barcode);
      formData.append(`variations[${index}][color_id]`, variation.color_id);
      formData.append(`variations[${index}][size_id]`, variation.size_id);
      formData.append(`variations[${index}][price]`, variation.price);
      formData.append(`variations[${index}][supplier_quantity]`, variation.quantity);
    });
  }

  if (data.variationImages && data.variationImages.length > 0) {
    data.variationImages.forEach((variation, index) => {
      appendVariationImages(formData, variation, index)
    });
  }
  return axios
    .post<any>(`${url}`, formData, {
      headers: {token: token || '', language, 'content-type': 'multipart/form-data'},
    })
    .catch((error) => {

      if (error.response && error.response.status === 400) {
        return {errors:error.response.data.error}
      }
    })
}
export function saveProductDraft(
    language: string,
    token: string | undefined,
    data: productState,
    productID: string | undefined | null,
    shopUser: boolean = false
) {
  const formData = new FormData()

  if (productID) {
    const regex2 = /(\d+)(?=&|$)/;
    let match =  productID.match(regex2)
    formData.append('request_id', match ? match[1] : '')
  }

  // Only send the default image when the user actually uploaded a new file.
  // image.value can also be the placeholder URL, an existing image URL/object
  // (on draft re-save), or '' — posting those makes the backend's image-format
  // validation reject the whole draft. Omitting them lets the draft save and
  // preserves the existing image on re-save. Mirrors the product_image[] guard.
  if (data.image.value instanceof File) {
    formData.append('image', data.image.value)
  }

  formData.append('barcode', data.barcode.value)
  if(!productID){
    formData.append('category', data.categoryName.value)
  }
  formData.append('categoryID', data.categoryID.value)
  formData.append('generate_flag', String(data.generate_flag) ?? '')

  formData.append('price', data.salePrice.value ?? '')
  formData.append('supplier_quantity', data.quantity.value ?? '')
  if (tenantTaxEnabled()) {
    formData.append('tax_type', data.tax_class_id.value ?? '')
  }
  formData.append('manufacturer_id', data.manufacturer_id.value ?? '')
  formData.append('model', data.model.value ?? '')
  formData.append('company_code', data.companyCode ?? '')
  formData.append('product_description[1][name]', data.productNameEn.value ?? '')
  formData.append('product_description[1][description]', data.productDescriptionEn.value ?? '')
  formData.append('product_description[6][name]', data.productNameAr.value ?? '')
  formData.append('product_description[6][description]', data.productDescriptionAr.value ?? '')

  if (data.aboutEn.value) {
    formData.append('product_description[1][about_product]', data.aboutEn.value)
  }

  if (data.aboutAr.value) {
    formData.append('product_description[6][about_product]', data.aboutAr.value)
  }

  formData.append('color_id', data.color ?? '')
  formData.append('gender_id', data.gender ?? '')

  formData.append('length', data.dimensionL ?? '')
  formData.append('length_class_id', data.lengthClass ?? '')
  formData.append('width', data.dimensionW ?? '')
  formData.append('height', data.dimensionH ?? '')
  formData.append('recommended_age_id', data.recommendedAge.value ?? '')

  formData.append('weight', data.weight ?? '')
  formData.append('weight_class_id', data.weightClass ?? '')
  formData.append('youtube_video_url', data.youtubeUrl ?? '')
  // A shop never sees the Expiry date field (the server ignores it for a shop), so it is not sent:
  // a stored past date would otherwise refuse the edit on a field the shop cannot fix.
  if (!shopUser) {
    formData.append('expiry_date', data.expiryDate.value || '0000-00-00')
  }

  appendOrderedImages(formData, data.product_image)

  data.deleted_images.forEach((product_image_id) => {
    formData.append('deleted_images[]', product_image_id)
  })

  if (data.variations && data.variations.length > 0) {
    data.variations.forEach((variation, index) => {
      formData.append(`variations[${index}][barcode]`, variation.barcode);
      formData.append(`variations[${index}][color_id]`, variation.color_id);
      formData.append(`variations[${index}][size_id]`, variation.size_id);
      formData.append(`variations[${index}][price]`, variation.price);
      formData.append(`variations[${index}][supplier_quantity]`, variation.quantity);
    });
  }

  if (data.variationImages && data.variationImages.length > 0) {
    data.variationImages.forEach((variation, index) => {
      appendVariationImages(formData, variation, index)
    });
  }
  return axios
      .post<any>(`${SAVE_DRAFT}`, formData, {
        headers: {token: token || '', language, 'content-type': 'multipart/form-data'},
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          return {errors:error.response.data.error}
        }
        // Re-throw anything that isn't a 400 validation error (500, network,
        // timeout) so callers' try/catch can surface it. Swallowing it here
        // made the promise resolve to `undefined`, which the save-draft
        // handlers read as success and navigated away without saving.
        throw error
      })
}

export function validateImages(
    language: string,
    token: string | undefined,
    data: File[],
) {
  if (!data || data.length === 0) {
    throw new Error("No files to validate");
  }
  const formData = new FormData();

  data.forEach((file) => {
    if (file instanceof File) {
      formData.append('product_image[]', file);
    }
  });

  return axios.post<any>(`${VALIDATE_PRODUCT_IMAGES}`,
      formData,
      {
        headers: {
          token: token || '',
          language: language,
          'Content-Type': 'multipart/form-data',
        },
      }
  );
}
export function checkDuplicateBarcode(
    barcode: string | undefined | null,
    token: string | undefined,
    language: string,
) {

  return axios.post<any>(`${VALIDATE_ADD_PRODUCT}`, { barcode: barcode },
  {
    headers: {token: token || '', language: language },
  });
}
export function getLengthClasses(token: string | undefined, language: string) {
  return axios.get<any>(`${GET_LENGTH_CLASSES}`, {headers: {token: token || '', language}})
}
export function setDiscountToInactive(
    token: string | undefined, language: string, product_special_id: string |undefined
){
  const data = { product_special_id };
  return axios.put<any>(
      `${SET_PRODUCT_TO_INACTIVE}`,
      data,
      {
        headers: { token: token || '', language: language }
      }
  );
}
export function getCategoryAutoComplete(
    token: string | undefined,
    language: string,
    name: string
){
  return axios.get<any>(
      `${AUTO_COMPLETE_CATEGORIES}`,
      {
        headers: { token: token || '', language},
        params: { name: name }
      }
  );
}

export function getCategoryLayer(
    token: string | undefined,
    language: string,
    parent_id: number
){
  return axios.get<any>(
      `${CATEGORIES_LAYERS}`,
      {
        headers: { token: token || '', language},
        params: { parent_id: parent_id }
      }
  );
}
export function getWeightClasses(token: string | undefined, language: string) {
  return axios.get<any>(`${GET_WEIGHT_CLASSES}`, {headers: {token: token || '', language}})
}
export function getColors(token: string | undefined, language: string) {
  return axios.get<any>(`${GET_COLORS}`, {headers: {token: token || '', language}})
}
export function getSizes(token: string | undefined, language: string) {
  return axios.get<any>(`${GET_SIZES}`, {headers: {token: token || '', language}})
}
export function getRecommendedAges(token: string | undefined, language: string) {
  return axios.get<any>(`${GET_RECOMMENDED_AGES}`, {headers: {token: token || '', language}})
}
export function getTax(token: string | undefined, language: string) {
  return axios.get<any>(`${GET_TAX}`, {headers: {token: token || '', language}})
}
export function getGenders(token: string | undefined, language: string) {
  return axios.get<any>(`${GET_GENDERS}`, {headers: {token: token || '', language}})
}
export function getBrands(token: string | undefined, language: string) {
  return axios.get<any>(`${GET_BRANDS}`, {headers: {token: token || '', language}})
}

// GET PRODUCTS LIST
export function getProductsList(
  filtersObj: any,
  token: string | undefined,
  language?: string,
  type?: PRODUCT_REQUEST_TYPE
) {
  return axios.get<{data: {products: IProductModel[]; total_products: number, limit: number}}>(
    `${GET_PRODUCTS_LIST}${filtersObj}${type ? '&request_type=' + type : ''}`,
    {headers: {token: token || '', language: language || 'en'}}
  )
}

export function getDraftProductsList(
    filtersObj: any,
    token: string | undefined,
    language?: string,
    type?: PRODUCT_REQUEST_TYPE
) {
  return axios.get<{product_requests: IProductDraftModel[]}>(
      `${GET_DRAFT_PRODUCTS_LIST}${filtersObj}${type ? '&request_type=' + type : ''}`,
      {headers: {token: token || '', language: language || 'en'}}
  )
}

export function deleteDraftProduct(
  requestId: number,
  token: string | undefined,
  language?: string
) {
  return axios.delete<{status: number; message: string}>(DELETE_DRAFT_PRODUCT, {
    headers: {token: token || '', language: language || 'en'},
    params: {request_id: requestId},
  })
}

// GET PRODUCTS LIST REQ
export function getProductsListReq(
  filtersObj: any,
  token: string | undefined,
  language?: string,
  type?: PRODUCT_REQUEST_TYPE
) {
  if (filtersObj === '') filtersObj = '?'
  return axios.get<any>(
    `${GET_PRODUCTS_REQ_LIST}${filtersObj}${type ? '&request_type=' + type : ''}`,
    {headers: {token: token || '', language: language || 'en'}}
  )
}

// GET ADD DISCOUNT REQ LIST
export function getAddDiscountReq(filtersObj: any, token: string | undefined, language?: string) {
  return axios.get<any>(`${GET_ADD_DISCOUNT_REQ_LIST}${filtersObj}`, {
    headers: {token: token || '', language: language || 'en'},
  })
}

// UPDATE PRODUCT
export function updateProduct(data: any, token: string | undefined, language?: string) {
  return axios.post<any>(`${EDIT_PRODUCT}`, data, {
    headers: {token: token || '', language: language || 'en'},
  })
}

// UPDATE PRODUCT
// like:
// out-of-stock?product_id=47979
export function productAction(
  filtersObj: any,
  action: PRODUCT_ACTIONS,
  token: string | undefined,
  language?: string
) {
  return axios.put<any>(
    `${PRODUCT_ACTION}${action}?${prepareFilterParams(filtersObj)}`,
    {},
    {headers: {token: token || '', language: language || 'en'}}
  )
}

// GET PRODUCT INFO
export function getProduct(product_id: number | string, language: string, token: string | undefined) {
  return axios.get<any>(`${GET_PRODUCT_INFO}?product_id=${product_id}`, {
    headers: {token: token || '', language: language },
  })
}
export function getRequestDataToEdit(product_id: number | string, request_type: string , language: string, token: string | undefined) {
  return axios.get<any>(`${GET_REQUEST_INFO}?request_id=${product_id}&request_type=${request_type}`, {
    headers: {token: token || '', language: language },
  })
}

export function getDailyDealList(token: string | undefined, language?: string) {
  return axios.get<any>(
      `${GET_DAILY_DEAL_LIST}`,
      {headers: {token: token || '', language: language || 'en'}}
  )
}

export function dailyDealAction(
    supplier_deal_id: number | string,
    action: DAILY_DEAL_ACTIONS,
    token: string | undefined,
) {
  return axios.delete<any>(` ${DELETE_DAILY_DEAL_PRODUCT}?supplier_deal_id=${supplier_deal_id}`, {
    headers: {token: token || ''},
  })
}

export async function addDailyDealProduct(token: string | undefined, language: string,
                                          data: {
                                            product_ids: number[];
                                            discount_date: string;
                                            quantity: number;
                                            discount_percentage: string;
                                          }
) {
  // New selection flow: stage the supplier's chosen winning-offer products
  // with one shared discount/quantity/date. POST a JSON body (the backend
  // branches on `product_ids`; the legacy barcode path stays for mobile).
  return axios.post<any>(`${ADD_ADD_DAILY_DEAL_PRODUCT}`, data, {
    headers: {token: token || '', language: language || 'en'},
  })
}

export function applyDailyDealProduct(token: string | undefined, language: string) {
  return axios.get<any>(` ${APPLY_DAILY_DEAL_PRODUCT}`, {
    headers: {token: token || '',language: language || 'en'},
  })
}

export function getAppliedDailyDealList(token: string | undefined, language: string) {
  return axios.get<any>(` ${APPLIED_DAILY_DEAL_LIST}`, {
    headers: {token: token || '', language: language || 'en'},
  })
}

export function getLossOfOpportunityProductsList(filtersObj: any, token: string | undefined,language:string) {
  return axios.get<any>(
      `${GET_LOSS_PRODUCTS_LIST}${filtersObj}${filtersObj === '' ? '?' : '&'}`,
      {headers: {token: token || '',language: language}}
  )
}
